import { AttaHttpClientFactory } from '@/services/http/AttaHttpClientFactory'
import Fuse from 'fuse.js'
import AutoCompleteBasico from './AutocompleteBasico'

let citiesFuse = new Fuse(new Array<any>(), { keys: ['nome'] })

const http = AttaHttpClientFactory.create(import.meta.env.VUE_APP_API_ATTA_SERVICES)

export interface ICityItem {
	id: number
	nome: string
}

export async function GetCitiesByState(uf: string) {
	var response = await http.get<{ result: ICityItem[]; error?: any }>(`/ibge/estados/${uf}/municipios`)
	return response.data
}

export const SelectCity = AutoCompleteBasico.extend({
	name: 'SelectCity',
	extends: AutoCompleteBasico,
	props: {
		state: { default: '', type: String },
		labelName: { default: 'Cidade' },
		placeholder: { default: 'Selecione uma cidade' },
		itemText: { default: 'nome' },
		itemValue: { default: 'nome' },
		noFilter: { default: true }
	},

	data: () => ({
		isLoading: false
	}),

	computed: {
		cities(): Array<any> {
			//@ts-ignore citiesFuse._docs is defined in function
			if (!this.query) return citiesFuse._docs
			return citiesFuse.search(this.query).map((u) => u.item)
		},

		computedProps(): Object {
			let props = {
				props: {
					...this.$props,
					rules: this.computedRules,
					loading: this.isLoading,
					items: this.cities
				}
			}

			return props
		}
	},

	mounted() {
		this.loadCitiesData()
	},

	methods: {
		async loadCitiesData() {
			this.isLoading = true

			if (this.state) {
				try {
					var response = await GetCitiesByState(this.state)
					if (!response.error) {
						citiesFuse = new Fuse(response.result, { keys: ['nome'] })
						this.query = ''
					}
					//if (!response.error) return response.result
				} catch (error) {}
			}

			this.isLoading = false
		},

		handleInput(value: string) {
			this.$emit('input', value)
		}
	},

	watch: {
		state: {
			handler: function () {
				this.loadCitiesData()
			}
		}
	}
})

export default SelectCity
